'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _rxjs = require('rxjs');

var _rxjs2 = _interopRequireDefault(_rxjs);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/BackToTop.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackToTop = function (_BcReactComponent) {
  _inherits(BackToTop, _BcReactComponent);

  function BackToTop(props) {
    _classCallCheck(this, BackToTop);

    var _this = _possibleConstructorReturn(this, (BackToTop.__proto__ || Object.getPrototypeOf(BackToTop)).call(this, props));

    _this.state = {
      visible: false
    };

    _this.lastScrollPosition = 0;
    _this.animationFrame = null;

    _this.bindAll('handleClick', 'handleScroll');
    return _this;
  }

  _createClass(BackToTop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.intervalScrollChecker = setInterval(function () {
        _this2.animationFrame = window.requestAnimationFrame(_this2.handleScroll);
      }, this.props.scrollWaitTime);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.intervalScrollChecker) {
        window.clearInterval(this.intervalScrollChecker);
      }

      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var initialScrollY = window.pageYOffset || document.documentElement.scrollTop;
      var frameRate = 1000 / 60; // 60 FPS
      var animationDuration = this.props.animationDuration;

      var easingFnc = function easingFnc(time, begin, change, duration) {
        return (// Cubic out
          change * ((time = time / duration - 1) * time * time + 1) + begin
        );
      }; // eslint-disable-line

      _rxjs.Observable.timer(0, frameRate, _rxjs2.default.Scheduler.animationFrame).map(function (i) {
        return i * frameRate;
      }).map(function (time) {
        return easingFnc(time, initialScrollY, -initialScrollY, animationDuration);
      }).concat(_rxjs.Observable.of(0)).takeWhile(function (val) {
        return val > 0;
      }).subscribe(function (val) {
        return window.scroll(0, val);
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var startPos = this.lastScrollPosition;
      var endPos = window.pageYOffset;
      var scrollDifference = Math.abs(endPos - startPos);
      var scrolledFarEnough = Math.min(endPos, scrollDifference) > this.props.scrollUpwardsThreshold;

      if (scrolledFarEnough) {
        var amountNeededToScroll = window.innerHeight * (this.props.percentViewportScrolled / 100.0);
        var visible = endPos > amountNeededToScroll && endPos < startPos;
        this.setState({
          visible: visible
        });
      }

      this.lastScrollPosition = endPos;
    }
  }, {
    key: 'render',
    value: function render() {
      var classnames = (0, _classnames2.default)('cp-back-to-top', { 'scrolled-visible': this.state.visible });
      return _react2.default.createElement(
        _baseButtons.SecondaryButton,
        { className: classnames, handleClick: this.handleClick },
        _react2.default.createElement(_baseIcons.Arrows.medium.Up, { color: '#fff' }),
        ' ',
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back_to_top' })
      );
    }
  }]);

  return BackToTop;
}(_baseBcReactComponent2.default);

exports.default = BackToTop;


BackToTop.propTypes = {
  // How long to wait for scrolling before calculating if the button should show
  scrollWaitTime: _react.PropTypes.number,

  // How far down the page the user has to have already scrolled before the button is allowed to be shown
  // This is relative to the viewport, so if the value is 50%, the user must have scrolled 234px on a 468px height device
  percentViewportScrolled: _react.PropTypes.number,

  // How many pixels the user must scroll upwards before the button is shown
  scrollUpwardsThreshold: _react.PropTypes.number,

  // Duration of the scroll to top animation
  animationDuration: _react.PropTypes.number
};

BackToTop.defaultProps = {
  scrollWaitTime: 50,
  percentViewportScrolled: 40,
  scrollUpwardsThreshold: 20,
  animationDuration: 700
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-back-to-top/lib/components/BackToTop.component.js
// module id = 1028
// module chunks = 1